import { render } from "./Authenticate.vue?vue&type=template&id=0f84ada0&scoped=true"
import script from "./Authenticate.vue?vue&type=script&lang=js"
export * from "./Authenticate.vue?vue&type=script&lang=js"

import "./Authenticate.vue?vue&type=style&index=0&id=0f84ada0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f84ada0"]])

export default __exports__